import { render, staticRenderFns } from "./pubrecruit.vue?vue&type=template&id=2414f5a2&scoped=true&"
import script from "./pubrecruit.vue?vue&type=script&lang=js&"
export * from "./pubrecruit.vue?vue&type=script&lang=js&"
import style0 from "./pubrecruit.vue?vue&type=style&index=0&id=2414f5a2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414f5a2",
  null
  
)

export default component.exports